export default function getErrorState(path) {
  if (!path) {
    throw new Error(`Validation not found for ${path}`);
  }

  return path.$invalid && path.$dirty;
}
